import { SerializedStyles } from "@emotion/react";
import { Ref, memo } from "react";
import { FormFlowPage, TextInput } from "src/components";

import { useMaybeSubmit } from "../hooks";
import { styles } from "../styles";

export interface RentalIncomeProps {
  value?: string;
  onChange?: (value?: string) => void;
  propertyAddress?: string;
  isSubpage?: boolean;

  focusRef?: Ref<HTMLInputElement>;
  onNext: () => void;
  style?: SerializedStyles;
}

const RentalIncome = ({
  value,
  onChange,
  onNext,
  style,
  focusRef,
  propertyAddress,
  isSubpage = false,
  ...props
}: RentalIncomeProps) => {
  const { handleNext, nextDisabled, nextLoading } = useMaybeSubmit({ onNext, shouldSubmit: !isSubpage });

  return (
    <FormFlowPage
      {...props}
      title={`What is the monthly rental income for ${propertyAddress || "the property"}?`}
      description="Please enter in the most recent information."
      onNext={handleNext}
      nextDisabled={nextDisabled}
      nextLoading={nextLoading}
      style={style}
    >
      <TextInput
        ref={focusRef}
        maskOptions={{
          rightAlign: false,
          alias: "currency",
          prefix: "$ ",
          jitMasking: false,
          digits: 0,
        }}
        max={100000000}
        style={styles.input}
        name="rentalIncome"
        label="Rental income"
        placeholder="2000.00"
        value={value || ""}
        onChange={onChange}
      />
    </FormFlowPage>
  );
};

export default memo(RentalIncome);
